import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import Popout from '@/components/Icons/Popout';
import { CsrfForm } from '@/components/Molecules/CsrfForm/CsrfForm';
import useTranslation from '@/hooks/useTranslation';
import { trackEvent } from '@/services/Analytics/BBAnalytics';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
interface IProps {
  eventId: string;
}

/**
 * A button that handles the launch of an event.
 */
export const LaunchEventButton = t0 => {
  const $ = _c(12);
  const {
    eventId
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] !== t) {
    t1 = t("Event.LaunchEventButton.launchEvent");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  const t2 = `/events/${eventId}/registration`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      action: "launch"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Popout />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== eventId) {
    t5 = () => trackEvent(TrackingAction.Open, TrackingCategory.Event, eventId);
    $[4] = eventId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5 || $[7] !== title) {
    t6 = <Button kind="tertiary" icon={t4} type="submit" onClick={t5}>{title}</Button>;
    $[6] = t5;
    $[7] = title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <CsrfForm apiUrl={t2} values={t3}>{t6}</CsrfForm>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};